import { render, staticRenderFns } from "./SalesItems.vue?vue&type=template&id=2ae0f36d&"
import script from "./SalesItems.vue?vue&type=script&lang=js&"
export * from "./SalesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports